<template>
  <v-container fluid>
   <div v-if="authenticated">
    <v-layout align-start wrap justify-start>
      <v-flex xs12>
          <div>
            <location-select complabel="Viewing"></location-select>
            <v-btn icon @click="loadData()"><v-icon>refresh</v-icon></v-btn>
          </div>
      </v-flex>
      </v-layout>
      <v-layout align-start wrap justify-start>
      <v-flex xs12>
          <v-card elevation="0">
              <v-card-title>
                <span class="tableHeading">Showing active firings for <v-icon class="dArrow">trending_flat</v-icon> {{ getSelectedLocation().name }}</span><v-spacer></v-spacer>
                <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
              </v-card-title>
              <v-data-table
                    :headers="headers"
                    :items="firingsData"
                    :search="search"
                >
                <template slot="items" slot-scope="props">
                <td>{{ props.item.name }}</td>
                <td class="text-xs-right">{{ props.item.userId }}</td>
                <td class="text-xs-right">{{ props.item.status }}</td>
                <td class="text-xs-right">{{ props.item.startDate }}</td>
                <td class="text-xs-right">{{ props.item.coolingDate }}</td>
                <td class="text-xs-right">{{ props.item.stopDate }}</td>
                <td class="text-xs-right">{{ props.item.firingDuration }}</td>
                <td class="text-xs-right">{{ props.item.duration }}</td>
                <td class="text-xs-right">{{ props.item.maxTemperature }}</td>
                <td class="text-xs-right">{{ props.item.lowestHourlyRate }}</td>
                <td class="text-xs-right">{{ props.item.highestHourlyRate }}</td>
                </template>
                <v-alert slot="no-results" :value="true" color="error" icon="warning">
                  No results found for "{{ search }}"
                </v-alert>
            </v-data-table>
          </v-card>
      </v-flex>
      <v-snackbar v-model="snackbar" :bottom="y === 'bottom'" :left="x === 'left'" :multi-line="mode === 'multi-line'"
        :right="x === 'right'" :timeout="timeout" :top="y === 'top'" :vertical="mode === 'vertical'" color='warning'>
        {{ text }}
        <v-btn color="black" flat @click="snackbar = false">Close</v-btn>
      </v-snackbar>
    </v-layout>
    </div>
  </v-container>
</template>

<script>
import axios from "axios"
import { mapState, mapGetters } from 'vuex';
import LocationSelect from '../components/LocationSelectComponent'

  export default {
    data() {
        return {
            urlData: "/thermocouple-services/tc/control/",
            firingsData: [],
            snackbar: false,
            y: 'top',
            x: 'left',
            mode: '',
            timeout: 5000,
            text: '',
            search: '',
            headers: [
                {
                    text: 'Firing',
                    align: 'left',
                    sortable: true,
                    value: 'name'
                },
                { text: 'Run By', value: 'userId' },
                { text: 'Status', value: 'status' },
                { text: 'Started', value: 'startDate' },
                { text: 'Cooling', value: 'coolingDate' },
                { text: 'Completed', value: 'stopDate' },
                { text: 'Firing Duration', value: 'firingDuration' },
                { text: 'Duration', value: 'duration' },
                { text: 'High Temp', value: 'maxTemperature' },
                { text: 'Low Rate', value: 'lowestHourlyRate' },
                { text: 'High Rate', value: 'highestHourlyRate' }
                ]
            }
    },
    components: {
        LocationSelect
    },
    methods: {
        ...mapGetters([
            'getLoggedInUser',
            'getSelectedLocation',
            'getAuthToken'
        ]),
        loadData() {
            if ( this.getSelectedLocation().name === 'Select' ) {
                this.text = 'Select a location first'
                this.snackbar = true;
            }  else {
                var url         = this.secureHost + this.urlData + this.getLoggedInUser().accountId + "/" + this.getSelectedLocation().name + "/active";
                axios({ method: "GET", "url": url, "headers": { "Accept": "application/json", "Authorization": this.getAuthToken() } }).then(result => {
                        this.firingsData = result.data.firings;
                    }).catch(error => {
                        this.text = 'Error retrieving firings data'
                        this.snackbar = true;
                    });
            }
        }
    },
    computed: {
        ...mapState([
            'authenticated',
            'secureHost',
            'range'
        ])
    }
  }
</script>

<style scoped>
.dArrow {
    min-width: 20px;
    font-size: 16px;
    vertical-align: middle
}
.tableHeading {
    font-size: 20px;
    font-weight: bold
}
</style>